<template>
    <div class="stepper">
        <div class="font-weight-bold title mb-4" :class="{'px-3': $vuetify.breakpoint.xs}"><slot></slot></div>
        <stepperItem v-for="(item, i) in steps" :key="i" :active="item.active"
                     :disabled="item.disabled" :lesson="i" :block='block_index'
        >{{ item.text }}</stepperItem>
    </div>
</template>

<script>
import stepperItem from './stepper_item';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    stepperItem,
  },
  props: {
    steps: {
      type: Array,
    },
    block_index: {
      type: Number,
    },
  },
  computed: {
    ...mapGetters('course_info/steps', [
      'lessons_total',
      'blocks',
      'items_for_block',
    ]),
  },
};
</script>

